"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _content = _interopRequireDefault(require("./content"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Modal = function Modal(props) {
  return props.open ? /*#__PURE__*/_react.default.createElement(_content.default, props) : null;
};

Modal.defaultProps = {
  isDismissable: true,
  theme: 'light'
};
Modal.propTypes = {
  open: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  showConfirmationOnClose: _propTypes.default.bool,
  clickOutsideCloses: _propTypes.default.bool,
  width: _propTypes.default.oneOf([1, 2, 3]),
  children: _propTypes.default.element.isRequired,
  isDismissable: _propTypes.default.bool.isRequired
};
var _default = Modal;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Modal, "Modal", "/Users/darcy/sites/cs-theme/src/components/modal/index.js");
  reactHotLoader.register(_default, "default", "/Users/darcy/sites/cs-theme/src/components/modal/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();